import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';
import { environment } from '@environments/environment';
import { enableDebugTools } from '@angular/platform-browser';

// Declare global window interface for appSettings
declare global {
  interface Window {
    appSettings: any;
  }
}

// Get settings from global variable (set in index.html)
function getAppSettings(): any {
  if (typeof window !== 'undefined' && window.appSettings) {
    return window.appSettings;
  }
  
  // Fallback to environment settings if window.appSettings is not available
  console.warn('window.appSettings not found, using fallback environment settings');
  return environment;
}

// Load settings synchronously from script block
const appSettings = getAppSettings();

// Apply settings to environment
environment.baseAPIUrl = appSettings.baseAPIUrl;
environment.apiServer = new URL(appSettings.baseAPIUrl).origin;
environment.production = appSettings.production;
environment.userManagementUrl = appSettings.userManagementUrl;
environment.manageUserUrl = appSettings.userManagementProfileUrl;
environment.changePasswordUrl = appSettings.userManagementPasswordUrl;
environment.dataModelEditorUrl = appSettings.dataModelEditorUrl;
environment.rechercheUrl = appSettings.rechercheUrl;
environment.maxAllowedImportSizeInMB = appSettings.maxAllowedImportSizeInMB || 25;
environment.tableStateMaxAgeInSeconds = appSettings.tableStateMaxAgeInSeconds || null;

if (environment.production) {
  console.log('%c Mode: production ', 'background: #090; color: #fff; font-size: large');
  enableProdMode();
} else {
  console.log('%c Mode: development ', 'background: #900; color: #fff; font-size: large');
  console.log('%c SETTINGS ', 'background: #333; color: #fff');
  for (const setting of Object.keys(environment)) {
    console.log('%c ' + setting + ': ', 'font-size: x-small; color: #aaa', JSON.stringify(environment[setting]));
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(moduleRef => {
    const applicationRef = moduleRef.injector.get(ApplicationRef);
    const componentRef = applicationRef.components[0];
    // allows to run `ng.profiler.timeChangeDetection();`
    enableDebugTools(componentRef);
  })
  .catch(err => console.log(err));
